import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonTabBar, IonTabButton, IonTabs, IonLabel, IonIcon, IonPage, IonRouterOutlet } from '@ionic/vue';
import { logoElectron, logoApple, watch } from 'ionicons/icons';

export default /*#__PURE__*/_defineComponent({
  __name: 'TabsPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonTabs), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRouterOutlet)),
          _createVNode(_unref(IonTabBar), { slot: "bottom" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonTabButton), {
                tab: "tab1",
                href: "/tabs/tab1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    "aria-hidden": "true",
                    icon: _unref(logoElectron)
                  }, null, 8, ["icon"]),
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode("Own Implementation")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTabButton), {
                tab: "tab2",
                href: "/tabs/tab2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    "aria-hidden": "true",
                    icon: _unref(logoApple)
                  }, null, 8, ["icon"]),
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode("Accelerator")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTabButton), {
                tab: "tab3",
                href: "/tabs/tab3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    "aria-hidden": "true",
                    icon: _unref(watch)
                  }, null, 8, ["icon"]),
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode("Orientation")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTabButton), {
                tab: "tab4",
                href: "/tabs/tab4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    "aria-hidden": "true",
                    icon: _unref(watch)
                  }, null, 8, ["icon"]),
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode("Geolocation")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTabButton), {
                tab: "tab5",
                href: "/tabs/tab5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    "aria-hidden": "true",
                    icon: _unref(watch)
                  }, null, 8, ["icon"]),
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode("Permissions")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})